import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://denizufiyhjqhoeruipb.supabase.co';
const supabaseKey = 'sb_publishable_gl02DVWQ2Wxe2M0Nza9p-A_RKxhWP7V';

// We create a function to initialize the client with the secret code header
export const getSupabaseClient = (secretCode) => {
  return createClient(supabaseUrl, supabaseKey, {
    global: {
      headers: {
        'x-memories-code': secretCode || '',
      },
    },
  });
};

// Default client (unauthenticated)
export const supabase = createClient(supabaseUrl, supabaseKey);
